module.exports = __webpack_public_path__ + "static/media/alliedhealth.fc5f5da6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/AlliedHealth/alliedhealth.svg
// module id = 471
// module chunks = 0